import React from 'react';
import './LicensePageNoSeat.css';
import { useMsal } from '@azure/msal-react';

const LicensePageNoSeat = () => {
    const { instance, accounts } = useMsal();

    return (
        <div className='license-page d-flex'>
            <div className={`d-flex align-items-center justify-content-center w-100`}>
                <div className={`card license-card w-75`}>
                    <div className="card-body p-5">
                        <h2>Access Denied</h2>
                        <p>You do not have an assigned seat in this license. Please contact your system administrator for assistance.</p>
                        {accounts.length > 0 && <small>Currently logged in as {accounts[0].username}</small>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LicensePageNoSeat;
